<template>
  <CompaniesTable
    v-bind:showSyncButton="true"
    :tableName="$t('salesPartnershipsLabel')"
    v-bind:parentCompanyId="0"
    v-bind:canModify="true"
    v-bind:canAddNew="false"
  />
</template>

<script>
import CompaniesTable from "../../components/CompaniesTable";
import UserTypes from "../../auth/userTypes";

export default {
  components: {
    CompaniesTable,
  },
};
</script>

<style lang="scss">
.tab-title {
  word-break: break-word;
}
</style>